import React from 'react';
import { XIcon } from 'lucide-react';
const pains = ["Splitting the class in two because half the group can't do what the other half is working on", "Planning next week's group lesson on your night off — unpaid", 'Out of warm-up games by week six, and the kids have played them all', 'No time to watch each skater do what you just told them to do', 'A 60-minute sheet of ice and nothing written for it yet', 'The beginner by the boards waiting while the advanced skaters get your attention', 'Choreographing the end-of-season group number from zero, again', 'Fitting lesson prep around a second job'];
export function PainGrid() {
  return <section aria-labelledby="pain-heading" className="w-full bg-rink" data-id="element-287" data-mp="1brnvrsas2sn1">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20" data-id="element-288" data-mp="17ptyzv3pe8s5">
        <div className="text-center" data-id="element-289" data-mp="364dm601xtjpo">
          <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-amber" data-id="element-290" data-mp="363c43bmi7wyg">
            The part nobody pays you for
          </p>
          <h2 id="pain-heading" className="mt-3 font-display font-bold text-white text-3xl sm:text-4xl md:text-5xl leading-tight" data-id="element-291" data-mp="3g9d0fp101rvk">
            If you coach group skating, you know at least{' '}
            <span className="text-coral-soft" data-id="element-292" data-mp="379gjk9kupxb2">half of this list.</span>
          </h2>
        </div>

        <ul className="mt-9 grid gap-3 text-left sm:grid-cols-2 sm:gap-x-5" data-id="element-293" data-mp="3bb1rrhmfxnex">
          {pains.map(pain => <li key={pain} className="flex items-start gap-3 rounded-card border border-rink-line bg-rink-card px-4 py-4 text-sm text-white/85" data-id="element-294" data-mp="2uqiwh8kihv8">
              <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-coral/20" data-id="element-295" data-mp="3q67wm19svg6o">
                <XIcon className="h-3 w-3 text-coral-soft" aria-hidden="true" data-id="element-296" data-mp="3u7bfyxr23ucn" />
              </span>
              {pain}
            </li>)}
        </ul>

        <p className="mt-10 text-center font-display font-semibold text-2xl sm:text-3xl text-amber leading-tight" data-id="element-297" data-mp="qlvxkt2rv43y">
          How many more Sunday nights do you want to spend drawing circuits?
        </p>
      </div>
    </section>;
}